/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useState, useEffect, useCallback, useRef} from "react";
import {Button} from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {Link} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {styled} from "@mui/material/styles";

import {useApiCallback} from "../util/Api";
import {useWebsocketStore} from "../service/WebSock";
import Container from "@mui/material/Container";


/** A hidden input field for handling the html-input file upload DOM element **/
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const BACKSPACE = '\x08';


export default function Import() {
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState([])
    const [idtoken, setIdtoken] = useState('')
    const [host, setHost] = useState('')
    const [count, setCount] = useState(20)
    const doImport = useApiCallback('POST', `/api/import`, {data: {idtoken}, setLoading, onDone: setStatus})
    const doImportStatus = useApiCallback('POST', `/api/import/status`, {data: {idtoken}, setLoading, onDone: setStatus})

    useEffect(() => {
        const it = setTimeout(() => {
            if (count > 0)
                setCount(count => count - 1)
        }, 1000)
        return () => clearTimeout(it)
    }, [setCount, count])

    const [tables, setTables] = useState('')
    const [file, setFile] = useState(null);
    const dbBackup = useApiCallback('POST', '/api/db/backup', {setLoading, onDone: setStatus});
    const dbRestore = useApiCallback('POST', '/api/db/restore', {setLoading, onDone: setStatus});
    const dbDownload = useApiCallback('GET', '/api/db/backup/download', {setLoading});

    useEffect(() => {
        return setFile(null)
    }, [status, setFile]);

    const fileinput = useRef()

    const addMsgHandler = useWebsocketStore(state => state.addMsgHandler);
    const removeMsgHandler = useWebsocketStore(state => state.removeMsgHandler);

    const processMsg = useCallback(lastMessage => {
        if (typeof lastMessage === 'undefined' || !lastMessage) return

        if (lastMessage.data instanceof ArrayBuffer) {
            return
        }
        try {
            const data = JSON.parse(lastMessage.data);
            if (data?.type === 'db_import_status' || data?.type === 'db_export_status') {
                console.log('adding export/import status line', data.msg);
                const st = status ? [...status] : [];
                if (data.msg.startsWith(BACKSPACE) && st.length) {
                    st.pop();
                }
                st.push(data.msg);
                return setStatus(st);
            }
        } catch (e) {
            console.error(e)
        }
    }, [status])

    useEffect(() => {
        addMsgHandler(processMsg);
        return () => removeMsgHandler(processMsg);
    }, [processMsg, addMsgHandler, removeMsgHandler]);

    const handleChange = useCallback(e => {
        e.preventDefault()
        e.stopPropagation()
        setFile(fileinput.current.files[0])
        return false
    }, [setFile])

    useEffect(() => {
        if (!fileinput.current) return
        const cur = fileinput.current;
        cur.addEventListener('change', handleChange)
        return () => {
            try {
                cur.removeEventListener('change', handleChange)
            } catch (e) {
            }
        }
    }, [fileinput, handleChange])

    return <Stack justifyContent="center" alignItems="center" >
        <Typography component="h2" sx={{m:4}}>Import configuration - Welcome to the Danger Zone</Typography>
        <Typography color="error">
        <strong>DO NOT RUN THIS unless you know what you are doing.
            This action will replace existing configuration on this portal.</strong>
        </Typography>
        {/*<TextField*/}
        {/*    label="host"*/}
        {/*    InputLabelProps={{shrink: true}}*/}
        {/*    value={host}*/}
        {/*    onChange={(event) => {*/}
        {/*        setHost(event.target.value)*/}
        {/*    }}*/}
        {/*    sx={{width: '300px', margin: 2}}*/}
        {/*/>*/}
        {/*<TextField*/}
        {/*    label="idtoken"*/}
        {/*    InputLabelProps={{shrink: true}}*/}
        {/*    value={idtoken}*/}
        {/*    onChange={(event) => {*/}
        {/*        setIdtoken(event.target.value)*/}
        {/*    }}*/}
        {/*    sx={{width: '300px', margin: 2}}*/}
        {/*/>*/}
        {/*<Stack direction="row" alignItems="center" sx={{marginTop:5}}>*/}
        {/*    <Button disabled={status || count || loading} color="error" onClick={() => doImport()}>Run {count ? count : ''}</Button>*/}
        {/*    <Button disabled={loading} color="error" onClick={() => doImportStatus()}>Import Status Only</Button>*/}
        {/*</Stack>*/}

        <Stack direction="row" justifyContent="center" alignItems="center" mt={5}>
            <TextField
                label="tables"
                InputLabelProps={{shrink: true}}
                value={tables}
                onChange={(event) => {
                    setTables(event.target.value.toLowerCase().replace(',', ' ').replace(/[^a-z0-9_ ]/, ''))
                }}
                sx={{width: '300px', margin: 2}}
            />
            <Button onClick={() => dbBackup({tables})}>DB Backup</Button>
            <Button onClick={() => dbDownload()}>Download</Button>
        </Stack>

        <Stack direction="row" mt={5}>
            <Button aria-label="Upload DB File…" onClick={() => fileinput.current.click()} size="small">
                <VisuallyHiddenInput type="file" multiple={false} ref={fileinput}/>
                <CloudUploadIcon/>
                <Link ml={2}>Upload Backup…</Link>
            </Button>

            <Button disabled={!file} onClick={() => dbRestore(file)} color="error">DB Restore</Button>
        </Stack>

        <Container>
            <pre style={{width: '100%'}}>{status?.join("\n")}</pre>
        </Container>
    </Stack>
}
